import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ShowcaseContentSeoDto } from './ShowcaseContentSeoDto'
import { ShowcaseContentResourceDto } from './ShowcaseContentResourceDto'
import { ContentType } from './Enums'
/**
* Class ShowcaseContentItemDto
*  Полное представление материала для страницы витрины
*/
export class ShowcaseContentItemDto extends ActiveModel {

  /**
  * type
  * словарь значений публикуется под именем `ContentType`  *   * Тип контента; определяет отображение на витрине и правила валидации.  *   * - `Page` Страница  *   * Статическая страница («Доставка и оплата», положения)  * - `News` Новость  *   * Новость (лента с датой публикации)  * - `Article` Статья  *   * Статья блога (витрина — Phase 1)  * - `Instruction` Инструкция  *   * Инструкция (обычно с приложенными документами)  *   */
  @ActiveField(ContentType.PAGE)
  type: ContentType = ContentType.PAGE


/**
  * title
  * Публичный заголовок (H1).
  */
  @ActiveField('')
  title: string = ''


/**
  * slug
  * Эффективный slug материала в текущем канале<br>
  */
  @ActiveField('')
  slug: string = ''


/**
  * announce
  * Анонс/подводка для лент; fallback для meta description.
  */
  @ActiveField()
  announce?: null | string


/**
  * bodyJson
  * Тело — TipTap-документ; витрина рендерит блоки своими компонентами<br>(SKUBY-CMS-MODULE-SPEC.md §2.2)<br>
  */
  @ActiveField('')
  bodyJson: string = ''


/**
  * coverId
  * Обложка для лент; fallback для og:image. Domain.Entities.Resources.Resource.Id
  */
  @ActiveField()
  coverId?: null | string


/**
  * publishAt
  * Дата публикации: сортировка лент; для Domain.Entities.Content.ContentStatus.Scheduled —<br>момент автоперевода в Published (Phase 1)<br>
  */
  @ActiveField()
  publishAt?: null | string


/**
  * tags
  * Простые теги для фильтрации лент.  */
  @ActiveField({
    setter(model: ShowcaseContentItemDto, prop: string, value: Array<string>, receiver?: ShowcaseContentItemDto ) {
      return Reflect.set(
        model,
        prop,
        value ? (Array.isArray(value) ? value : [value])
          .map(v => String(v)) : value,
        
        receiver)
    }
  })
  tags: Array<string> = []


  /**
  * seo
  * SEO-атрибуты (для web-каналов; fallback-приоритеты применяет витрина)<br>  */
  @ActiveField({
    factory: [ShowcaseContentSeoDto, () => ShowcaseContentSeoDto.create()]
  })
  seo: ShowcaseContentSeoDto = ShowcaseContentSeoDto.create()


/**
  * @property resources
  * Приложенные файлы, видимые в текущем канале: галерея и документы<br>в порядке сортировки (SKUBY-CMS-MODULE-SPEC.md §3.4)<br>  */
  @ActiveField({
    factory: [ShowcaseContentResourceDto, () => []]
  })
  resources: Array<ShowcaseContentResourceDto> = []
}
